import {
  DurationVitalOptions,
  DurationVitalReference,
} from 'src/utilities/window';

export interface DurationVital {
  start: (options?: DurationVitalOptions) => Promise<DurationVitalReference>;
  stop: (params?: DurationVitalStopParams) => void;
}

export interface DurationVitalStopParams {
  reference?: DurationVitalReference;
  options?: DurationVitalOptions;
}

export enum DurationVitalStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
}
